// Quiz signatures invalidate passed answers when the video or questions change.
function validQuestions(questions) {
    return Array.isArray(questions) && questions.length > 0 && questions.every(q =>
        q && typeof q.prompt === 'string' && q.prompt.trim() && Array.isArray(q.options) &&
        q.options.length >= 2 && q.options.length <= 4 && q.options.every(o => typeof o === 'string' && o.trim()) &&
        new Set(q.options.map(o => o.trim().toLowerCase())).size === q.options.length &&
        Number.isInteger(q.correctOptionIndex) && q.correctOptionIndex >= 0 && q.correctOptionIndex < q.options.length)
}
function quizSignature(video) {
    return JSON.stringify([video?.video || '', (video?.questions || []).map(q => [q.prompt, q.options, q.correctOptionIndex])])
}
function answersCorrect(questions, answers) {
    return validQuestions(questions) && Array.isArray(answers) && answers.length === questions.length &&
        questions.every((q, i) => answers[i] === q.correctOptionIndex)
}
function quizPassed(video, saved) {
    return saved?.signature === quizSignature(video) && answersCorrect(video?.questions, saved?.answers)
}
function coachQuizRequired(category) {
    return category?.quizRequired === true || category?.name?.trim().toLowerCase() === 'coach upskilling videos'
}
module.exports = { validQuestions, quizSignature, answersCorrect, quizPassed, coachQuizRequired }
